import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCall"><Path d="M3.01311 3L3.00197 3.73869C3.00066 3.82564 3 3.91275 3 4C3 7.10297 3.83203 10.0139 5.28566 12.5194C6.77436 15.0853 8.9147 17.2256 11.4806 18.7143C13.9861 20.168 16.897 21 20 21H21V14.4388L15.7745 12.9019L14.0423 14.7063C12.0524 13.5965 10.4035 11.9476 9.29367 9.95774L11.0981 8.2255L9.56118 3H3.01311Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCall;
